import { Route, Routes } from 'react-router-dom';
import { Container } from 'src/Components';
import { BeneficiariesList, BeneficiariesNew } from './pages';
import { routerPath } from 'src/Config';
import { i18, trb } from 'src/Utilities';
import { Typography } from '../../../shared';

export const Beneficiaries = () => {
  return (
    <>
      <Typography.Title
        level={1}
        style={{ fontSize: '1rem', marginBottom: '20px' }}
        className="eb_content_subtitle fw-normal"
      >
        {trb(i18.ContentMenu.Beneficiaries)}
      </Typography.Title>
      <Container cardClassName="py-0">
        <Routes>
          <Route
            index
            element={<BeneficiariesList />}
          />
          <Route
            path={routerPath.beneficiariesNew}
            element={<BeneficiariesNew />}
          />
        </Routes>
      </Container>
    </>
  );
};
